"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _CacheHandler = _interopRequireDefault(require("../../../../../utils/CacheHandler"));
var _RegExUtils = require("../../../../../utils/RegExUtils");
var _meterReadingApi = require("../../../../../api-factory/meterReadingApi");
var _MeterReadingRegisterPropTypes = require("./MeterReadingRegisterPropTypes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MeterReadingRegister = function MeterReadingRegister(props) {
  var _CacheHandler$getCurr, _props$withoutRegiste, _props$withoutRegiste2, _props$activateButton, _props$activateButton2, _props$registerButton, _props$registerButton2;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dataProtectionAccepted = _useState2[0],
    setDataProtectionAccepted = _useState2[1];
  var _useState3 = (0, _react.useState)({
      email: '',
      inputStatus: _reactSharedUiNext.InputState.NONE,
      serverError: false,
      loading: false
    }),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  var checkEmail = function checkEmail(value) {
    var isEmailValid = value ? _RegExUtils.EMAIL_REGEX.test(String(value)) : false;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      email: value,
      inputStatus: isEmailValid ? _reactSharedUiNext.InputState.VALID : _reactSharedUiNext.InputState.ERROR,
      serverError: false
    }));
    return isEmailValid;
  };
  var okoSubscription = function okoSubscription() {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      loading: true
    }));
    var okoObj = {
      mailAddress: state.email,
      privacyPolicyAccepted: dataProtectionAccepted
    };
    var result = (0, _meterReadingApi.activateOko)(okoObj);
    result.then(function () {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        serverError: false
      }));
      props.onOkoSuccess(state.email);
    });
    result.catch(function () {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        serverError: true,
        inputStatus: _reactSharedUiNext.InputState.ERROR
      }));
    });
  };
  var defaultEmail = (_CacheHandler$getCurr = _CacheHandler.default.getCurrentCache().accountData) === null || _CacheHandler$getCurr === void 0 ? void 0 : _CacheHandler$getCurr.email;
  var errorMessage = state.serverError ? props.serverErrorMessage : props.emailValidationError;
  var dataProtectionText = /*#__PURE__*/_react.default.createElement("div", null, props.dataProtectionText1, ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: props.dataProtectionPageUrl,
    className: "meter-reading-register__data-protection-link"
  }, ' ', props.dataProtectionLabel), ' ', props.dataProtectionText2);
  if (state.loading) {
    return /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Loader, {
      loading: true,
      fallbackGifSrc: sessionStorage.fallbackLoader
    });
  }
  var okoClassContainer = !props.onlyGuestPortal ? 'meter-reading-register__oko-container' : 'meter-reading-register__oko-container-full-width';
  var okoBorderContainer = !props.onlyGuestPortal ? 'meter-reading-register__oko-border-container' : 'meter-reading-register__oko-border-container-full-width';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !props.onlyGuestPortal && /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__without-register-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__without-register-text-container"
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: "meter-reading-register__without-register-text"
  }, props.withoutRegisterText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__without-register-button-container"
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
    className: "meter-reading-register__button__without-register",
    version: (_props$withoutRegiste = props.withoutRegisterButton) === null || _props$withoutRegiste === void 0 ? void 0 : _props$withoutRegiste.version,
    id: "meter-reading-register-without-register-button",
    qaId: "meter-reading-register-without-register-button",
    onClick: function onClick() {
      return props.onNextStep(false);
    },
    autoFocus: false
  }, ' ', (_props$withoutRegiste2 = props.withoutRegisterButton) === null || _props$withoutRegiste2 === void 0 ? void 0 : _props$withoutRegiste2.label))), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: okoClassContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: okoBorderContainer
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "meter-reading-register__headline"
  }, props.readingCardHeadline), /*#__PURE__*/_react.default.createElement("p", {
    className: "meter-reading-register__description"
  }, props.readingCardSubline), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__form-input"
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.TextInput, {
    onBlur: function onBlur(e) {
      checkEmail(e.target.value);
    },
    onChange: function onChange(e) {
      checkEmail(e.target.value);
    },
    id: "meter-reading-register-input",
    qaId: "meter-reading-register-input",
    errorMessage: state.inputStatus === _reactSharedUiNext.InputState.ERROR ? errorMessage : '',
    type: "text",
    name: "email",
    value: state.email,
    defaultValue: defaultEmail,
    label: props.emailAddressLabel,
    inputState: state.inputStatus
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__data-protection-container"
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Checkbox, {
    name: "data-protection",
    id: "meter-reading-register-checkbox-data-protection",
    qaId: "meter-reading-register-checkbox-data-protection",
    label: dataProtectionText,
    checked: dataProtectionAccepted,
    onChange: function onChange() {
      return setDataProtectionAccepted(!dataProtectionAccepted);
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__button-container"
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
    className: "meter-reading-register__button__oko-activate",
    version: (_props$activateButton = props.activateButton) === null || _props$activateButton === void 0 ? void 0 : _props$activateButton.version,
    id: "meter-reading-register-oko-activate-button",
    qaId: "meter-reading-register-oko-activate-button",
    onClick: function onClick() {
      return okoSubscription();
    },
    autoFocus: false,
    disabled: state.inputStatus !== _reactSharedUiNext.InputState.VALID || !dataProtectionAccepted
  }, ' ', (_props$activateButton2 = props.activateButton) === null || _props$activateButton2 === void 0 ? void 0 : _props$activateButton2.label))), !props.onlyGuestPortal && /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__register-container"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "meter-reading-register__headline"
  }, props.registerForPortalHeadline), /*#__PURE__*/_react.default.createElement("p", {
    className: "meter-reading-register__description"
  }, props.registerForPortalSubline), /*#__PURE__*/_react.default.createElement("h5", {
    className: "meter-reading-register__benefits-text"
  }, props.yourBenefitsText), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container__arrow"
  }), props.yourBenefits.paperlessCommunication), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container__arrow"
  }), props.yourBenefits.meterShow), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container__arrow"
  }), props.yourBenefits.meterRemind), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container__arrow"
  }), props.yourBenefits.consumptionHistory), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__benefits-container__arrow"
  }), props.yourBenefits.addressChangeOnline), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-reading-register__button-container"
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
    className: "meter-reading-register__button__with-register",
    version: (_props$registerButton = props.registerButton) === null || _props$registerButton === void 0 ? void 0 : _props$registerButton.version,
    id: "meter-reading-register-with-register-button",
    qaId: "meter-reading-register-with-register-button",
    onClick: function onClick() {
      return props.onNextStep(true);
    },
    autoFocus: false
  }, ' ', (_props$registerButton2 = props.registerButton) === null || _props$registerButton2 === void 0 ? void 0 : _props$registerButton2.label)))));
};
MeterReadingRegister.propTypes = _MeterReadingRegisterPropTypes.meterReadingRegisterLabelPropTypes;
var _default = exports.default = MeterReadingRegister;